import { ButtonV2, Typography } from '../ui';

const ClearcoBanner = () => {
  return (
    <div className="p-5 bg-gray-2 flex items-center gap-5 mt-6 rounded-xl">
      <div className="bg-white p-3 rounded-xl h-[100px] w-[100px] min-w-[100px]  min-h-[100px] flex items-center justify-center">
        <img src="/partners/clearco-logo.svg" alt="clearco" />
      </div>

      <div className="flex flex-col gap-1 flex-1">
        <Typography variant="h5" as="h3" weight="bold">
          Need financing?
        </Typography>
        <Typography
          className="max-w-[100%] md:max-w-[720px]"
          variant="body-1"
          as="p"
          weight="regular"
        >
          Our partner Clearco provides ecommerce brands with working capital to
          fund invoices and receipts for inventory, marketing spend, and more.
          Manage cash flow and increase revenue with predictable, controllable,
          and scalable funding.
        </Typography>
      </div>

      <div>
        <ButtonV2
          onPress={() =>
            window.open('https://clear.co/partner/cavela', '_blank')
          }
        >
          See options
        </ButtonV2>
      </div>
    </div>
  );
};

export default ClearcoBanner;
